import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import home from '@/views/index.vue';

Vue.use(VueRouter);

/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  // @ts-ignore
  return originalPush.call(this, location).catch((err) => err);
};

const routes: Array<RouteConfig> = [
  {
    path: '*',
    name: 'index',
    component: home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
